// eslint-disable-next-line @typescript-eslint/no-explicit-any
import {removeNonDigitCharacters} from '@montana/helpers/string-format/string-format.helper';

export type IValidator = (value: any) => string | undefined;

export function combineValidators<TValue>(...validators: IValidator[]): IValidator {
    return (value: TValue): undefined | string => validators
        .map((validator): undefined | string => validator(value))
        .find((message): boolean => !!message);
}

export function required<TValue>(message: string): IValidator {
    return (value: TValue): undefined | string => (value ? undefined : message);
}

export function minLength<TValue extends { length: number }>(min: number, message: string): IValidator {
    return (value: TValue): undefined | string => (value.length >= min ? undefined : message);
}

export function maxLength<TValue extends { length: number }>(max: number, message: string): IValidator {
    return (value: TValue): undefined | string => (value.length <= max ? undefined : message);
}

export function exactLength<TValue extends { length: number }>(len: number, message: string): IValidator {
    return (value: TValue): undefined | string => ((value?.length === len) ? undefined : message);
}

export function noCityMatchZipCode(noMatch: boolean, message: string): IValidator {
    return (): undefined | string => (!noMatch ? undefined : message);
}

export function pattern(p: RegExp, message: string): IValidator {
    return (value: string): undefined | string => {
        return p.test(value) ? undefined : message;
    };
}

export function email(message: string): IValidator {
    return (value: string): undefined | string => pattern(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message)(value);
}

export function fullName(message: string): IValidator {
    return (value: string): undefined | string => pattern(/(\w.+\s).+/i, message)(value);
}

export function phone(marketId: string, message: string): IValidator {
    switch (marketId) {
        case 'DK':
            return (value: string): undefined | string => pattern(/^\d{8}$/i, message)(removeNonDigitCharacters(value));
        case 'SE':
            return (value: string): undefined | string => pattern(/^\d{7,9}$/i, message)(removeNonDigitCharacters(value));
        default:
            return (value: string): undefined | string => pattern(/^\d+$/i, message)(value);

    }
}

export function streetNumber(message: string): IValidator {
    return (value: string): undefined | string => pattern(/^\D+(\s).?[0-9]+/i, message)(value);
}

export function city(message: string): IValidator {
    return (value: string): undefined | string => pattern(/^\p{L}\D+$/iu, message)(value);
}
